import { motion } from 'framer-motion';
import { ArrowDown } from '@phosphor-icons/react';

const Hero = ({ content }) => {
    const title = content?.hero_title?.content || 'Engineering Solutions for Marine & Industrial Applications';
    const subtitle = content?.hero_subtitle?.content || 'Developing innovative software and engineering products for the maritime and industrial sectors';

    return (
        <section 
            className="relative min-h-screen flex items-center justify-center hero-bg"
            data-testid="hero-section"
        >
            {/* Background Image */}
            <div 
                className="absolute inset-0 bg-cover bg-center bg-no-repeat"
                style={{
                    backgroundImage: `url('https://images.unsplash.com/photo-1647053220306-2652eadbc4cd?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2Nzd8MHwxfHNlYXJjaHwzfHxvY2VhbiUyMHdhdmVzJTIwZGFya3xlbnwwfHx8fDE3NzU1OTE2MzZ8MA&ixlib=rb-4.1.0&q=85')`
                }}
            />
            
            {/* Content */}
            <div className="relative z-10 max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
                <motion.div
                    initial={{ opacity: 0, y: 30 }}
                    animate={{ opacity: 1, y: 0 }}
                    transition={{ duration: 0.8, ease: 'easeOut' }}
                    className="space-y-8"
                >
                    {/* Overline */}
                    <motion.div 
                        initial={{ opacity: 0 }}
                        animate={{ opacity: 1 }}
                        transition={{ delay: 0.2 }}
                    >
                        <span className="text-sm uppercase tracking-[0.2em] font-bold text-secondary">
                            Spindrift Engineering Limited
                        </span>
                    </motion.div>

                    {/* Main Title */}
                    <motion.h1
                        initial={{ opacity: 0, y: 20 }}
                        animate={{ opacity: 1, y: 0 }}
                        transition={{ delay: 0.3, duration: 0.8 }}
                        className="text-4xl sm:text-5xl lg:text-7xl font-light tracking-tighter text-text-primary leading-none max-w-5xl mx-auto"
                        data-testid="hero-title"
                    >
                        {title}
                    </motion.h1>

                    {/* Subtitle */}
                    <motion.p
                        initial={{ opacity: 0, y: 20 }}
                        animate={{ opacity: 1, y: 0 }}
                        transition={{ delay: 0.5, duration: 0.8 }}
                        className="text-lg sm:text-xl text-text-secondary max-w-2xl mx-auto leading-relaxed"
                        data-testid="hero-subtitle"
                    >
                        {subtitle}
                    </motion.p>

                    {/* CTA Buttons */}
                    <motion.div
                        initial={{ opacity: 0, y: 20 }}
                        animate={{ opacity: 1, y: 0 }}
                        transition={{ delay: 0.7, duration: 0.8 }}
                        className="flex flex-col sm:flex-row gap-4 justify-center pt-4"
                    >
                        <a
                            href="#software"
                            className="btn-primary px-8 py-3 rounded-sm text-text-primary font-medium text-sm inline-flex items-center justify-center gap-2"
                            data-testid="hero-cta-software"
                        >
                            Explore Our Software
                        </a>
                        <a
                            href="#about"
                            className="btn-secondary px-8 py-3 rounded-sm text-text-primary font-medium text-sm inline-flex items-center justify-center gap-2"
                            data-testid="hero-cta-about"
                        >
                            Learn More
                        </a>
                    </motion.div>
                </motion.div>

                {/* Scroll indicator */}
                <motion.div
                    initial={{ opacity: 0 }}
                    animate={{ opacity: 1 }}
                    transition={{ delay: 1, duration: 1 }}
                    className="absolute bottom-8 left-1/2 transform -translate-x-1/2"
                >
                    <a 
                        href="#about" 
                        className="flex flex-col items-center gap-2 text-text-muted hover:text-text-secondary transition-colors"
                        data-testid="scroll-indicator"
                    >
                        <span className="text-xs uppercase tracking-wider">Scroll</span>
                        <ArrowDown size={20} className="animate-bounce" />
                    </a>
                </motion.div>
            </div>
        </section>
    );
};

export default Hero;
